export const OPEN_MODAL = "SET_MODAL_STATE";
export const HIDE_MODAL = "HIDE_MODAL";

type ModalType = "substitute" | "feedback" | null;

type ModalState = {
    isOpen: boolean;
    modalType: ModalType;
};

const initialState: ModalState = {
    isOpen: false,
    modalType: null
};

const modalReducer = (state = initialState, action) => {
    switch (action.type) {
        case OPEN_MODAL:
            return {
                isOpen: true,
                modalType: action.payload.modalType
            };
        case HIDE_MODAL:
            if (state.modalType === action.payload.modalType) {
                return {
                    isOpen: false,
                    modalType: null
                };
            }
            return state;
        default:
            return state;
    }
};

export const showModal = (modalType: string) => ({ type: OPEN_MODAL, payload: { modalType } });
export const hideModal = (modalType: string) => ({ type: HIDE_MODAL, payload: { modalType } });

export default modalReducer;
